import { type CSSProperties } from 'react'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { LinkToWebhook } from '@eggplant/routing'
import { PiWarning } from 'react-icons/pi'

const disabledWebhookInfo: CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'auto 1fr',
  columnGap: '4px',
  marginTop: '8px'
}

const DisabledWebhookNote = () =>
  <div style={disabledWebhookInfo}>
    <Color variant='orange'>
      <PiWarning
        aria-hidden
        size='16px'
      />
    </Color>
    <Paragraph>
      <Color variant='theme-description-text'>
        <span>
          This webhook profile is disabled. Notifications for this profile will not be sent. You can enable the webhook profile in the
          {' '}
          <LinkToWebhook
            isInlineLink
            isRenderIcon
            openInNewTab
          >
            webhook
          </LinkToWebhook>
          {' '}
          page.
        </span>
      </Color>
    </Paragraph>
  </div>

export default DisabledWebhookNote
